import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash'

import { clearAllFilters } from '../redux/actions/applyFilters'
import { setSearchResults } from '../redux/actions/setSearchResults'

export function useSearchResultsEventListener() {
  const dispatch = useDispatch()

  useEffect(() => {
    function onReceiveSearchResults(event) {
      const results = _.get(event, 'detail.tourIds', [])
      const formattedResults = _.reduce(results, (resultMap, item) => ({
        ...resultMap,
        [item.tourID]: item,
      }), {})
      dispatch(clearAllFilters())
      dispatch(setSearchResults({...event.detail, tourIds: formattedResults }))
    }

    window.addEventListener('ylg_site_search_results', onReceiveSearchResults)
    return () => window.removeEventListener('', onReceiveSearchResults)
  }, [dispatch])
}
